import api from "./api";

class EventService {
  /**
   * Get paginated list of events
   * @param {Object} filters - Filter options
   * @returns {Promise} API response
   */
  async getEvents(filters = {}) {
    try {
      const params = new URLSearchParams();

      if (filters.page !== undefined)
        params.append("page", filters.page.toString());
      if (filters.size !== undefined)
        params.append("size", filters.size.toString());
      if (filters.universityId)
        params.append("universityId", filters.universityId.toString());
      if (filters.campusId)
        params.append("campusId", filters.campusId.toString());
      if (filters.clubId) params.append("clubId", filters.clubId.toString());
      if (filters.status !== undefined && filters.status !== "") {
        params.append("status", filters.status.toString());
      }
      if (filters.eventStatus)
        params.append("eventStatus", filters.eventStatus);

      const response = await api.get(`/api/admin/events?${params}`);
      return response.data;
    } catch (error) {
      throw error;
    }
  }

  /**
   * Get event by ID
   * @param {number} id - Event ID
   * @returns {Promise} API response
   */
  async getEvent(id) {
    try {
      const response = await api.get(`/api/admin/events/${id}`);
      return response.data;
    } catch (error) {
      throw error;
    }
  }

  /**
   * Create new event
   * @param {Object} data - Event data
   * @returns {Promise} API response
   */
  async createEvent(data) {
    try {
      const response = await api.post("/api/admin/events", data);
      return response.data;
    } catch (error) {
      throw error;
    }
  }

  /**
   * Update event
   * @param {number} id - Event ID
   * @param {Object} data - Event data
   * @returns {Promise} API response
   */
  async updateEvent(id, data) {
    try {
      const response = await api.put(`/api/admin/events/${id}`, data);
      return response.data;
    } catch (error) {
      throw error;
    }
  }

  /**
   * Delete event
   * @param {number} id - Event ID
   * @returns {Promise} API response
   */
  async deleteEvent(id) {
    try {
      const response = await api.delete(`/api/admin/events/${id}`);
      return response.data;
    } catch (error) {
      throw error;
    }
  }

  /**
   * Get available addresses for event creation
   * @param {number} clubId - Club ID
   * @param {number} universityId - University ID
   * @returns {Promise} API response
   */
  async getAvailableAddresses(clubId, universityId) {
    try {
      const params = new URLSearchParams({
        clubId: clubId.toString(),
        universityId: universityId.toString(),
      });
      const response = await api.get(`/addresses/available?${params}`);
      return response.data;
    } catch (error) {
      throw error;
    }
  }

  /**
   * Create new address
   * @param {Object} data - Address data
   * @returns {Promise} API response
   */
  async createAddress(data) {
    try {
      const addressData = {
        longitude: parseFloat(data.longitude),
        latitude: parseFloat(data.latitude),
        descriptionEn: data.descriptionEn,
        descriptionLocal: data.descriptionLocal,
        createdByClubId: data.createdByClubId,
        universityId: data.universityId || null,
        campusId: data.campusId || null,
      };
      const response = await api.post("/addresses", addressData);
      return response.data;
    } catch (error) {
      throw error;
    }
  }
}

const eventService = new EventService();
export default eventService;
